import { render, staticRenderFns } from "./controlHistory.vue?vue&type=template&id=0a96c38a&scoped=true"
import script from "./controlHistory.vue?vue&type=script&lang=js"
export * from "./controlHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96c38a",
  null
  
)

export default component.exports